<template>
  <div class="edit-customer">
    <CModal
      color="primary"
      :show.sync="isShowPopup"
      :close-on-backdrop="false"
      size="lg"
    >
      <template #header>
        <h6 class="modal-title">Edit Partner</h6>
        <CButtonClose @click="modalCallBack(false)" class="text-black" />
      </template>
      <template #footer>
        <CButton
          type="button"
          color="primary"
          variant="outline"
          class="px-4"
          @click="modalCallBack(false)"
          >Cancel</CButton
        >
        <CButton type="button" color="primary" class="px-4" @click="onSubmit"
          >Update</CButton
        >
      </template>
      <LoadingOverlay v-if="isFetchingFilter" />
      <div v-else>
        <ValidationObserver ref="editPartner" v-slot="{ handleSubmit }">
          <form id="editPartner" @submit.prevent="handleSubmit(onSubmit)">
            <CRow>
              <CCol lg="6">
                <CRow name="institution_name" class="mb-3">
                  <label class="required col-lg-12 col-md-12"
                    >Institution Name</label
                  >
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <TextInput
                        name="name"
                        :value="partner.name"
                        @input="handleInput"
                        :error="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </CRow>
              </CCol>
              <CCol md="6">
                <CRow class="row mb-3">
                  <label name="lbl_upload-document" class="col-lg-12 col-md-12"
                    >Partner Logo</label
                  >
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <input
                      name="upload-document"
                      type="file"
                      ref="fileref"
                      :accept="arraytoComma(fileType)"
                      @change="selectedFile"
                    />
                  </div>
                </CRow>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <CRow class="mb-3" name="country">
                  <label class="required col-lg-12 col-md-12">Country</label>
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <Select
                        name="country_id"
                        :value="partner.country_id"
                        :options="
                          options && options['country']
                            ? options['country']
                            : []
                        "
                        :multiple="false"
                        :clearable="false"
                        @input="handleChangeMultiSelect"
                        :error="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </CRow>
              </CCol>
              <CCol lg="6">
                <CRow name="tags" class="mb-3">
                  <label class="required col-lg-12 col-md-12">Tags</label>
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <Select
                        name="tags"
                        :value="partner.tags"
                        :options="
                          options && options['tags'] ? options['tags'] : []
                        "
                        :multiple="true"
                        :clearable="false"
                        @input="handleChangeSelect"
                        :error="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </CRow>
              </CCol>
              <CCol lg="12">
                <CRow name="institution_name" class="mb-3">
                  <label class="required col-lg-12 col-md-12"
                    >Description</label
                  >
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <RichTextEditor
                        name="quick_description"
                        :value="partner.quick_description"
                        @input="handleInput"
                        :error="errors[0]"
                        :customToolbar="customToolbar"
                      />
                    </ValidationProvider>
                  </div>
                </CRow>
              </CCol>
            </CRow>
          </form>
        </ValidationObserver>
      </div>
      <CropperModal
        v-if="cropperModal.isShowPopup"
        :isShowPopup="cropperModal.isShowPopup"
        :fileData="cropperModal.fileData"
        modalColor="primary"
        :buttonLabel="cropperModal.buttonLabel"
        @modalCallBack="cropperModalCallBack"
        :aspectRatio="cropperModal.aspectRatio"
      />
    </CModal>
    <CToaster v-if="isFileError" :autohide="3000" position="top-right">
      <CToast :show="true" class="bg-danger text-white"
        >File too Big, please select a file less than 2mb</CToast
      >
    </CToaster>
    <CToaster v-if="isFileTpeValid" :autohide="5000" position="top-right">
      <CToast :show="true" class="bg-danger text-white"
        >Allowed File Type {{ FileTypeError }}</CToast
      >
    </CToaster>
  </div>
</template>
<script>
import Vue from "vue";

import Select from "@/components/reusable/Fields/Select.vue";
import TextInput from "@/components/reusable/Fields/TextInput";
import _ from "lodash";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import RichTextEditor from "@/components/reusable/Fields/RichTextEditor";
import CropperModal from "@/components/reusable/CropperModal";
import { mapGetters, mapActions } from "vuex";

extend("required", { ...required, message: "This field is required" });

export default {
  props: {
    partnerDetail: {
      type: Object,
      default: () => null,
    },
    isShowPopup: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    Select,
    TextInput,
    CropperModal,
    RichTextEditor,
  },
  data() {
    return {
      fileType: ["png", "jpeg", "jpg"],

      payload: {},
      partner: {},
      isFileError: false,
      isFileTpeValid: false,
      FileTypeError: null,
      cropperModal: {
        isShowPopup: false,
        fileData: null,
        buttonLabel: "Apply",
        aspectRatio: 1,
      },
      customToolbar:[
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [{ header: 1 }, { header: 2 }],
        [{ align: [] }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ script: "sub" }, { script: "super" }],
        [{ direction: "rtl" }],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link"],
        ["clean"], // remove formatting button
      ]
    };
  },
  computed: {
    ...mapGetters([
      "locationCountryInfo",
      "dialingCodeWithCountryCode",
      "getCustomerTypeList",
      "selectedCustomer",
      "isFetchingFilter",
      "getOrganisationTypeList",
      "getLocationByCountryID",
      "getLocationByCountrysID",
    ]),
    tags() {
      return [
        "Hospital/Clinic",
        "Pharmaceuticals",
        "Education",
        "Governmental",
        "Regulatory Body",
        "Service Provider",
        "Consulting",
        "Supplier",
      ];
    },
    options() {
      return {
        customer_type: this.getCustomerTypeList || [],
        country: this.locationCountryInfo || [],
        organization_type: this.getOrganisationTypeList || [],
        tags: this.tags || [],
      };
    },
  },
  methods: {
    ...mapActions(["initUserFetchOptions", "showToast"]),
    arraytoComma(d) {
      return d?.map((v) => "." + v).join(", ");
    },
    getExtension(filename) {
      let parts = filename.split(".");
      return `${parts[parts.length - 1]}`;
    },
    handleInput(name, value) {
      Vue.set(this.partner, name, value);
      Vue.set(this.payload, name, value);
    },
    handleChangeSelect(name, value) {
      Vue.set(this.partner, name, value);
      this.payload = {
        ...this.payload,
        [name]: value ? value.id || value.code || value : null,
      };
    },
    handleChangeMultiSelect(name, value) {
      Vue.set(this.partner, name, value);
      this.payload = {
        ...this.payload,
        [name]: value
          ? (value.id || value.code || value)
          : null,
      };
    },
    cancelUpdate() {
      this.$router.push({ path: `/partner-list` });
    },
    async onSubmit() {
      const isValid = await this.$refs.editPartner.validate();
      if (!isValid) {
        this.showToast({
          class: "bg-danger text-white",
          message: "please fill mandatory fields!",
        });
        return;
      }
      this.payload.org_name = this.payload.name;
      this.modalCallBack(true, this.payload);
    },
    modalCallBack(action, payload) {
      this.$emit("modalCallBack", action, payload);
    },
    selectedFile(event) {
      this.isFileError = false;
      this.isFileTpeValid = false;
      const size = event.target.files[0]?.size;
      if (Math.round(size / (1024 * 1024)) <= 2) {
        const file = event.target.files[0];
        const fileExt = this.getExtension(file.name);
        const fileTypeString = this.fileType;
        if (fileTypeString.includes(fileExt)) {
          if (file.type.startsWith("image/")) {
            this.cropperModal.fileData = file;
            this.cropperModal.isShowPopup = true;
          } else {
            this.handleFileUploads(file);
          }
        } else {
          this.isFileTpeValid = true;
          this.FileTypeError = this.arraytoComma(fileTypeString);
          this.$refs.fileref.value = "";
          this.showToaster();
        }
      } else {
        this.$refs.fileref.value = "";
        this.isFileError = true;
        this.showToaster();
      }
    },
    showToaster() {
      setTimeout(() => {
        this.isFileError = false;
        this.isFileTpeValid = false;
      }, 5000);
    },
    cropperModalCallBack(action, data) {
      if (action === false) {
        this.cropperModal.isShowPopup = false;
        this.cropperModal.fileData = null;
        this.$refs.fileref.value = "";
      } else {
        let { fileBlob, fileName } = data;
        const payload = {
          organisation_id : this.partnerDetail.organisation.organisation_id,
          fileName,
          blobData: fileBlob,
          document_type_id: 17, // Logo - Document Type Id
          organisation_document_id: this.partnerDetail.documents?.[0]?.document_id
        };
        this.payload = {
          ...this.payload,
          file_payload: payload,
        };
        this.cropperModal.isShowPopup = false;
        this.cropperModal.fileData = null;
      }
    },
  },
  mounted() {
    this.initUserFetchOptions();
    const partnerData = this.partnerDetail;
    this.partner = {
      name: partnerData.name,
      country_id: {
        code: partnerData.country_id,
        label: partnerData.country_name,
      },
      quick_description: partnerData.quick_description,
      tags: partnerData.tags,
      is_parent_admin: partnerData?.main_organisation?.is_parent,
    };
    this.payload = {
      name: partnerData.name,
      tags: partnerData.tags,
      quick_description: partnerData.quick_description,
      organisation_type_id: partnerData.organisation?.organisation_type_id,
      org_name: partnerData.organisation?.org_name,
      customer_type_id: partnerData.customer_type_id,
      country_id: partnerData.country_id,
      customer_id: partnerData.customer_uid,
      organisation_id: partnerData.organisation?.organisation_id,
    };
  },
};
</script>

<style scoped>
.edit-customer {
  color: #212529 !important;
}
</style>